/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Enable_PreviewInputs */

const en_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable ADR Preview`)
};

const fr_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer l'aperçu ADR`)
};

const de_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR-Vorschau aktivieren`)
};

const it_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita anteprima ADR`)
};

const ru_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить предварительный просмотр ADR`)
};

const es_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar la vista previa de ADR`)
};

const zh_cn2_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用 ADR 预览`)
};

const ja_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADRプレビューを有効にする`)
};

const hi_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडीआर पूर्वावलोकन सक्षम करें`)
};

const pt_pt2_options_adr_enable_preview = /** @type {(inputs: Options_Adr_Enable_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar a pré-visualização de ADR`)
};

/**
* | output |
* | --- |
* | "Enable ADR Preview" |
*
* @param {Options_Adr_Enable_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_enable_preview = /** @type {((inputs?: Options_Adr_Enable_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Enable_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_enable_preview(inputs)
	if (locale === "de") return de_options_adr_enable_preview(inputs)
	if (locale === "it") return it_options_adr_enable_preview(inputs)
	if (locale === "ru") return ru_options_adr_enable_preview(inputs)
	if (locale === "es") return es_options_adr_enable_preview(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_enable_preview(inputs)
	if (locale === "ja") return ja_options_adr_enable_preview(inputs)
	if (locale === "hi") return hi_options_adr_enable_preview(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_enable_preview(inputs)
	return en_options_adr_enable_preview(inputs)
});